export default __webpack_public_path__ + "static/media/FreakyDDS.10701bbb.jpeg";